import { lazy, Suspense, FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { PdpSharedSendToFriendModalLazy_viewer } from './__generated__/PdpSharedSendToFriendModalLazy_viewer.graphql';
import { PdpSharedSendToFriendModalLazy_user } from './__generated__/PdpSharedSendToFriendModalLazy_user.graphql';
import { PdpSharedSendToFriendModalLazy_item } from './__generated__/PdpSharedSendToFriendModalLazy_item.graphql';

const PdpSharedSendToFriendModal = lazy(
    () => import(/* webpackChunkName: "AuthShareModal" */ './AuthShareModal')
);

type Props = {
    closeModal: () => void;
    hasError?: boolean;
    isLoggedIn?: boolean;
    modalOpen: boolean;
    onUserLogin?: () => void;
    senderEmail?: string;
    setError: () => void;
    skuId?: string;
    imageSrc: string;
    type: string;
    user: PdpSharedSendToFriendModalLazy_user | null;
    item: PdpSharedSendToFriendModalLazy_item | null;
    viewer: PdpSharedSendToFriendModalLazy_viewer | null;
};

const PdpSharedSendToFriendModalLazyComponent: FC<Props> = props => {
    return props.modalOpen ? (
        <Suspense fallback={''}>
            <PdpSharedSendToFriendModal {...props} />
        </Suspense>
    ) : null;
};

export const PdpSharedSendToFriendModalLazy = createFragmentContainer(
    PdpSharedSendToFriendModalLazyComponent,
    {
        viewer: graphql`
            fragment PdpSharedSendToFriendModalLazy_viewer on Viewer {
                ...AuthShareModal_viewer
            }
        `,
        user: graphql`
            fragment PdpSharedSendToFriendModalLazy_user on User {
                ...AuthShareModal_user
            }
        `,
        item: graphql`
            fragment PdpSharedSendToFriendModalLazy_item on Item {
                ...AuthShareModal_item
            }
        `,
    }
);
